import type { ReactNode } from "react";

import { cn } from "../../utils/classnames";

type MediaFigureProps = {
  caption?: string;
  children: ReactNode;
  className?: string;
  credit?: string;
};

/**
 * Shared caption and credit chrome for the editorial media blocks, so an image,
 * a video, and an audio player are captioned identically wherever they appear.
 *
 * Renders a bare `<figure>` when there is nothing to caption rather than an
 * empty `<figcaption>`, which screen readers would announce as a caption.
 */
function MediaFigure({
  caption,
  children,
  className,
  credit,
}: MediaFigureProps) {
  const showCaption = caption || credit;

  return (
    <figure className={cn("my-6", className)}>
      {children}
      {showCaption ? (
        <figcaption className="mt-2 font-jakarta text-sm opacity-75">
          {caption ? (
            <span className={cn({ "mr-1": credit })}>{caption}</span>
          ) : null}
          {credit ? <span className="italic">{credit}</span> : null}
        </figcaption>
      ) : null}
    </figure>
  );
}

export { MediaFigure };
